import React, { useImperativeHandle, useState, useRef } from "react";
import { SmartFitnessBandDeleteContractDialog, SmartFitnessBandEditCreditCardDialog, SmartFitnessBandQuitDeleteDialog } from "@icoach/smartFitnessBand/dialog/";
import SmartFitnessBandSendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import { isEqual, isFunction } from "@util/utils";

const SMART_FITNESS_BAND_EDIT_CREDIT_CARD_DIALOG = "SmartFitnessBandEditCreditCardDialog";
const SMART_FITNESS_BAND_DELETE_CONTRACT_DIALOG = "SmartFitnessBandDeleteContract";
const SMART_FITNESS_BAND_SMS_DIALOG = "SmartFitnessBandSmsDialog";
const SMART_FITNESS_BAND_QUIT_DELETE_DIALOG = "SmartFitnessBandQuitDeleteDialog";

const SmartFitnessBandDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState({});
	const refreshRef = useRef(null);

	const doRefresh = () => isFunction(refreshRef.current) && refreshRef.current();

	useImperativeHandle(
		ref,
		() => {
			return {
				openSmartFitnessBandDeleteContractDialog: (targetData, _refreshFn = () => {}) => {
					refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_DELETE_CONTRACT_DIALOG);
				},
				openSmartFitnessBandEditCreditCardDialog: (targetData, _refreshFn = () => {}) => {
					refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_EDIT_CREDIT_CARD_DIALOG);
				},
				openSendSmsDialog: (targetData, refreshFn) => {
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_SMS_DIALOG);
					refreshRef.current = refreshFn;
				},
				openSmartFitnessBandQuitDeleteDialog: (targetData, _refreshFn = () => {}) => {
					refreshRef.current = _refreshFn;
					setSourceData(targetData);
					setOpenDialog(SMART_FITNESS_BAND_QUIT_DELETE_DIALOG);
				},
				closeDialog: () => handleCloseDialog(),
			};
		},
		// eslint-disable-next-line
		[]
	);

	const handleCloseDialog = () => {
		setOpenDialog(null);
		setSourceData(null);
		refreshRef.current = null;
	};

	return (
		<React.Fragment>
			<SmartFitnessBandSendSmsDialog open={isEqual(openDialog, SMART_FITNESS_BAND_SMS_DIALOG)} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
			<SmartFitnessBandDeleteContractDialog open={isEqual(openDialog, SMART_FITNESS_BAND_DELETE_CONTRACT_DIALOG)} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
			<SmartFitnessBandEditCreditCardDialog open={isEqual(openDialog, SMART_FITNESS_BAND_EDIT_CREDIT_CARD_DIALOG)} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
			<SmartFitnessBandQuitDeleteDialog open={isEqual(openDialog, SMART_FITNESS_BAND_QUIT_DELETE_DIALOG)} onClose={handleCloseDialog} sourceData={sourceData} refresh={doRefresh} />
		</React.Fragment>
	);
});

export default SmartFitnessBandDialogBox;
